import React from 'react';
import { useNavigate } from 'react-router-dom';

// First-run landing that briefly explains the Pet Escape Early Warning concept.
// Reuses the existing Lashachi visual system (no new tokens/fonts/graphics).
const Welcome = () => {
  const navigate = useNavigate();

  const start = () => {
    // Mark the intro as seen so the root gate renders Home afterwards.
    sessionStorage.setItem('lp_entered', '1');
    navigate('/');
  };

  return (
    <div
      className="h-full flex flex-col px-8 pt-10 pb-10 lp-enter"
      data-testid="welcome-screen"
    >
      {/* Brand */}
      <div className="flex items-center gap-2.5">
        <img
          src="/lashachi-pet-logo.png"
          alt="Lashachi Pet"
          className="w-[34px] h-[34px] rounded-[8px] object-contain"
          data-testid="welcome-logo"
        />
        <span className="font-serif-lp text-[19px]" style={{ color: 'var(--lp-cream)' }}>
          Lashachi <span style={{ color: 'var(--lp-body)' }}>Pet</span>
        </span>
      </div>

      {/* Center message */}
      <div className="flex-1 flex flex-col justify-center">
        <h1
          className="font-serif-lp text-[30px] leading-tight mb-4"
          style={{ color: 'var(--lp-cream)' }}
        >
          Early awareness when your pet may be approaching an exit repeatedly.
        </h1>
        <p
          className="font-geist-lp text-[15px] leading-relaxed"
          style={{ color: 'var(--lp-body)' }}
        >
          Lashachi uses activity observations from connected sources such as Ring
          to look for repeated activity near a designated exit.
        </p>
      </div>

      {/* Primary action */}
      <div>
        <button
          onClick={start}
          data-testid="welcome-get-started"
          className="lp-btn-sage lp-focus w-full text-[16px]"
          style={{ minHeight: 52 }}
        >
          Get Started
        </button>
        <p
          className="font-geist-lp text-[12.5px] text-center mt-4"
          style={{ color: 'var(--lp-muted)' }}
        >
          Warnings are provisional and based on observed activity patterns.
        </p>
      </div>
    </div>
  );
};

export default Welcome;
